function _encodePath(path) {
  let pathParts = path.split("/");
  let filename = pathParts[pathParts.length - 1];
  let encodedFileName = encodeURIComponent(filename);
  pathParts = pathParts.slice(0, pathParts.length - 1);
  pathParts.push(encodedFileName);
  let finalPath = pathParts.join("/") + "#t=0.1";
  return finalPath;
}
function normalizeCssVal(val) {
  if (Object.prototype.toString.call(val) === "[object Number]") {
    val = val.toString();
  }
  if (val.indexOf("%") >= 0 || val.indexOf("px") >= 0) {
    return val;
  }
  return `${val}px`;
}
function getVideoMimeType(filename) {
  const extension = filename.split('.').pop().toLowerCase();
  const mimeTypes = {
    'mp4': 'video/mp4',
    'webm': 'video/webm',
    'ogg': 'video/ogg',
    'ogv': 'video/ogv'
  };
  return mimeTypes[extension];
}
let VideoJs = function (settings) {
  return new Promise((resolve, reject) => {
    import("video.js").then(videojs => {
      // find wrapper
      let element;
      if (Object.prototype.toString.call(settings.selector) === "[object String]") {
        element = document.querySelector(settings.selector);
      } else {
        element = settings.selector;
      }
      let videoPath = _encodePath(settings.path);
      let videoHTML = `
                <video
                    ${settings.width ? 'width="' + settings.width + '"' : ""}
                    ${settings.height ? 'height="' + settings.height + '"' : ""}
                    ${settings.autoplay ? "playsinline muted" : ""}
                    preload="none" class="vplay-video-el video-js vjs-default-skin">
                </video>
            `;
      element.innerHTML = `
                <div class="vplay-wrapper ${settings.customClass ? settings.customClass : ""}" style="width: ${settings.width}; height: ${settings.height}">
                    <div data-vplay-video-wp style='display: none;'>

                    </div>
                </div>`;
      let videoWpElement = element.querySelector("[data-vplay-video-wp]");
      videoWpElement.style.display = "inherit";
      videoWpElement.innerHTML = videoHTML;
      let videoEl = videoWpElement.querySelector("video");
      let additionalPlugins = {
        vjsdownload: {
          beforeElement: "playbackRateMenuButton",
          textControl: "Download video",
          name: "downloadButton",
          downloadURL: settings.path
        }
      };
      if (!settings.showDownloadBtn) {
        delete additionalPlugins.vjsdownload;
      }
      let videoSettings = {
        controls: !settings.hideControls,
        autoplay: settings.autoplay,
        fluid: settings.fluid,
        loop: settings.loop,
        plugins: additionalPlugins,
        preload: "metadata"
      };
      if (settings.poster) {
        videoSettings.poster = settings.poster;
      }
      let player = videojs.default(videoEl, videoSettings);
      if (!settings.fluid) {
        if (settings.width) {
          player.el_.style.width = normalizeCssVal(settings.width);
        }
        if (settings.height) {
          player.el_.style.height = normalizeCssVal(settings.height);
        }
      }
      if (settings.lazyLoad) {
        player.src(null);
      } else {
        player.src({
          type: getVideoMimeType(settings.path),
          src: videoPath
        });
      }
      player.ready(() => {
        if (settings.autoplay) {
          setTimeout(function () {
            player.autoplay("muted");
          }, 0);
        }
      });
      resolve(player);
    });
  });
};
function initializeYouTubeVideos() {
  const containers = document.querySelectorAll('.cms-video');
  containers.forEach(container => {
    const posterElement = container.querySelector('[data-youtube-poster-wp]');
    const iframe = container.querySelector('iframe');
    const playButton = container.querySelector('[data-youtube-playbtn-wp]');
    if (posterElement && iframe && playButton) {
      setupYouTubeVideo(container, posterElement, iframe, playButton);
    }
  });
}
function setupYouTubeVideo(container, posterElement, iframe, playButton) {
  iframe.style.visibility = 'hidden';
  configurePlayButton(playButton);
  playButton.addEventListener('click', () => {
    const dataSrc = iframe.getAttribute('data-src');
    if (dataSrc && !iframe.getAttribute('src')) {
      iframe.setAttribute('src', dataSrc);
    }
    iframe.style.visibility = 'visible';
    posterElement.style.display = 'none';
  });
}
function configurePlayButton(playButton) {
  playButton.setAttribute('role', 'button');
  playButton.setAttribute('title', 'View Video');
  playButton.setAttribute('aria-label', 'View Video');
  playButton.setAttribute('tabindex', '0');
  playButton.addEventListener('keydown', event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      playButton.click();
      console.log('Video played');
    }
  });
}
document.addEventListener('DOMContentLoaded', initializeYouTubeVideos);
module.exports = VideoJs;